import React, { Component } from 'react'; 
import {getToolkitCategories, toolkitCategories} from '../../utils/categories';

import './Toolkit.css';
import { connect } from 'react-redux';
import ChooseCategory from '../../components/ChooseCategory/ChooseCategory';
import LearnMoreModal from './LearnMoreModal';

class ChooseToolkitCategory extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showLearnMoreOpenModal: false
    }
  }

  handleCategorySelection = (category) => {
    let link = '';
      for (let toolkitCategory of toolkitCategories) {
        if (toolkitCategory.name === category) {
          link = toolkitCategory.link;
        }
      }
    this.props.history.push({
      pathname: `/home/toolkit/${link}/add`,
      state: {category}
    });
  }

  toggleLearnMoreModal = () => this.setState({showLearnMoreOpenModal: !this.state.showLearnMoreOpenModal});

  render() { 
      let {showLearnMoreOpenModal} = this.state;
      let title = "Add a Resource";
      let description = "Add a resource or solution to improve Diversity and Inclusion. You can create a new resource or add an existing one. First select a category below.";
      let toolkitCategories = getToolkitCategories();
      let addToolkitCategories = toolkitCategories.map(category => category.name); 
    return (<div>
      <ChooseCategory
        title={title}
        description={description}
        categories={addToolkitCategories}
        onCategoryChoose={this.handleCategorySelection}
        type='Toolkit'
        onClickLearnMore={this.toggleLearnMoreModal}
      />
      <LearnMoreModal
        showModal={showLearnMoreOpenModal}
        toolkitCategories={toolkitCategories}
        toggle={this.toggleLearnMoreModal}
      />
    </div>
    );
  }
}
 
const mapStateToProps = state => {
	return {
    toolDetails : state.toolkit.toolDetails
	}
}

export default connect(mapStateToProps)(ChooseToolkitCategory);